import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'User',
    column_type: 'id',
  },
  created_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  screen_name: {
    model_name: 'User',
    column_type: 'string',
  },
  is_block: {
    model_name: 'User',
    column_type: 'boolean',
  },
  sns_authorized: {
    model_name: 'User',
    column_type: 'string',
  },
  login_activities_count: {
    model_name: 'User',
    column_type: 'integer',
  },
  wechat_mp_openid: {
    model_name: 'User',
    column_type: 'string',
  },
  profile: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'profile',
      model_name: 'Profile',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'profile',
      model_name: 'Profile',
      foreign_key: 'user_id',
    },
  },
  avatar: {
    model_name: 'User',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  accounts: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'accounts',
      model_name: 'Account',
      foreign_key: 'user_id',
    },
  },
  account_ids: {
    model_name: 'User',
    column_type: 'has_many',
    extra: {
      association_name: 'accounts',
      model_name: 'Account',
      foreign_key: 'user_id',
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
